module.exports = __webpack_public_path__ + "img/icon-score9.180eb979.svg";